/**
 * @file Timeline Add component
 * @author Willem Jan Weitering
 */
import { OnInit } from '@angular/core';
import { TimelineComponent } from '../timeline/timeline.component';
import { TimelineService } from '../timeline.service';
import { TimelineItemType } from '../helpers/timelineItem-type.enum';
import { ConfigurationsService } from '../../configurations.service';
import { UserService } from '../../user.service';
/**
 * This is a component shown in the timeline to add a message to the timeline
 */
var TimelineAddComponent = /** @class */ (function () {
    /**
     * Constructs a TimelineItem Component
     * @param timelineService The timelineService
     */
    function TimelineAddComponent(configurationsService, userService, timelineComponent, timelineService) {
        this.configurationsService = configurationsService;
        this.userService = userService;
        this.timelineComponent = timelineComponent;
        this.timelineService = timelineService;
        /* the text of the message to be, the text of the input */
        this.text = '';
        /* busy because message is being added? */
        this.isBusy = false;
    }
    /**
     * Handles input in input box
     * @param value text of input box
     */
    TimelineAddComponent.prototype.onInput = function (value) {
        this.text = value;
    };
    /**
     * Add user message to timeline
     */
    TimelineAddComponent.prototype.addMessage = function () {
        var _this = this;
        if (!this.text) {
            alert('this should not happen');
        }
        else {
            this.isBusy = true;
            setTimeout(function () {
                _this.timelineService.createTimelineItem(TimelineItemType.mind, _this.user.fullName + ' says:', _this.text, new Date(Date.now()), { fullName: _this.user.fullName, imageLink: 'https://randomuser.me/api/portraits/men/43.jpg' });
                _this.resetText();
                _this.isBusy = false;
            }, 2000);
        }
    };
    /**
     * reset input and do nothing more
     */
    TimelineAddComponent.prototype.cancelMessage = function () {
        this.resetText();
    };
    /**
     * reset text to empty string
     */
    TimelineAddComponent.prototype.resetText = function () {
        this.text = '';
    };
    Object.defineProperty(TimelineAddComponent.prototype, "user", {
        /** Gets the user info of the authenticated user. */
        get: function () {
            var user = this.userService.user;
            if (!user) {
                return undefined;
            }
            return user;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Is called directly after the creation of this component
     */
    TimelineAddComponent.prototype.ngOnInit = function () {
    };
    return TimelineAddComponent;
}());
export { TimelineAddComponent };
